module.exports = __webpack_public_path__ + "static/career-breakfast-meeting-1391882c40a9e0c7e5a798d3ef03c3e4.png";